<template>
  <ul class="nav header-navbar-rht">

    <!-- Seletor de Idioma -->
    <li class="nav-item dropdown language-selector">
      <a href="javascript:void(0)" class="dropdown-toggle" data-bs-toggle="dropdown" :title="$t('language.select')">
        <i class="feather-globe"></i>
        <span class="d-none d-md-inline ms-1">{{ currentLanguageLabel }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item" :class="{ active: currentLocale === 'pt-BR' }" @click="changeLanguage('pt-BR')">
          <span class="flag-icon">🇧🇷</span> {{ $t('language.portuguese') }}
        </a>
        <a class="dropdown-item" :class="{ active: currentLocale === 'es' }" @click="changeLanguage('es')">
          <span class="flag-icon">🇪🇸</span> {{ $t('language.spanish') }}
        </a>
        <a class="dropdown-item" :class="{ active: currentLocale === 'en' }" @click="changeLanguage('en')">
          <span class="flag-icon">🇺🇸</span> {{ $t('language.english') }}
        </a>
      </div>
    </li>

    <li class="nav-item user-nav">
      <a href="javascript:void(0)" class="dropdown-toggle" data-bs-toggle="dropdown">
          <span class="user-img">
              <img v-if="usuario && usuario.Foto" :src="usuario.Foto" alt=""/>
              <img v-else-if="getTheme == 'uca'" src="../assets/img/uca/avatar-icon.png" alt=""/>
              <img v-else-if="getTheme == 'esn'" src="../assets/img/esn/avatar-icon.png" alt=""/>
              <img v-else-if="getTheme == 'u4'" src="../assets/img/u4/avatar-icon.png" alt=""/>
              <span class="status online"></span>
          </span>
        <div class="user-header float-end px-0">
          <div class="user-text" v-if="usuario">
            <h6 class="m-0">{{ usuario.Nome }}</h6>
            <p class="text-muted mb-0 text-xs" v-if="usuario.Admin">{{ $t('header.administrator') }}</p>
            <p class="text-muted mb-0 text-xs" v-else>{{ usuario.Email }}</p>
          </div>
        </div>
      </a>
      <div class="users dropdown-menu dropdown-menu-right" data-popper-placement="bottom-end">
        <a class="dropdown-item cursor-pointer" @click="this.$router.push('/perfil')"><i class="feather-user me-1"></i>
          {{ $t('header.profile') }}</a>
        <a class="dropdown-item cursor-pointer" @click="this.$router.push('/perfil/alterar-senha')"><i
          class="feather-lock me-1"></i> {{ $t('header.changePassword') }}</a>
        <a class="dropdown-item cursor-pointer" v-if="usuarioAdministrativo" @click="abrirConfiguracoes">
          <i class="feather-settings me-1"></i> {{ $t('header.settings') }}
        </a>
        <a class="dropdown-item cursor-pointer"  @click="toggleDarkMode">
          <span v-if="darkModeEnabled"><i class="feather-sun me-1"/> {{ $t('header.lightMode') }}</span>
          <span v-else><i class="feather-moon me-1"/> {{ $t('header.darkMode') }}</span>
        </a>
        <a class="dropdown-item cursor-pointer" @click="logout"><i class="feather-log-out me-1"></i> {{ $t('header.logout') }}</a>
      </div>
      <ModalConfiguracoesUsuario
        :abrir="abrirModalConfiguracoes"
        @fechar="abrirModalConfiguracoes = false"
      />
    </li>

    <li class="nav-item noti-nav" v-if="temPermissaoMensagem">
      <a href="javascript:void(0)" class="dropdown-toggle notification-toggle" data-bs-toggle="dropdown"
         :title="temNova ? $t('header.newNotifications') : $t('header.noNotifications')">
        <img src="../assets/img/icon/notification.svg" alt="img" class="notification-icon"
             :class="{ 'notification-icon--pulse': temNova, 'notification-icon--muted': !temNova }">
        <span v-if="temNova" class="notification-label small text-muted">
          <span class="d-block text-xs">{{ $t('header.newMessagesShort1') }}</span>
          <span class="d-block text-xs">{{ $t('header.newMessagesShort2') }}</span>
        </span>
      </a>
      <div class="notifications dropdown-menu dropdown-menu-right">
        <div class="row">
          <div class="col-12">
            <div class="topnav-dropdown-header">
              <span class="fw-bold text-center" v-if="Mensagens > 0">{{ $t('header.unreadMessages', { count: Mensagens }) }}</span>
              <span class="text-muted text-center" v-else>{{ $t('header.allMessagesRead') }}</span>
              <a href="javascript:void(0)" class="clear-noti" @click="irParaMensagens('email')">
                <div>{{ $t('header.goToMessages') }} <i class="fa-solid feather-chevron-right"/></div>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="topnav-dropdown-header">
              <span class="fw-bold text-center" v-if="Notificacoes > 0">{{ $t('header.unreadNotifications', { count: Notificacoes }) }}</span>
              <span class="text-muted text-center" v-else>{{ $t('header.allNotificationsRead') }}</span>
              <a href="javascript:void(0)" class="clear-noti" @click="irParaMensagens('notificacao')">
                <div>{{ $t('header.goToNotifications') }} <i class="fa-solid feather-chevron-right"/></div>
              </a>
            </div>
          </div>
        </div>

<!--        <div class="noti-content">-->
<!--          <ul class="notification-list">-->

<!--            <li class="notification-message"-->
<!--                v-for="(notificacao, index) in MensagensNotificacao" :key="index">-->
<!--              <div class="media d-flex">-->
<!--                <div class="avatar">-->
<!--                  <img v-if="notificacao.FotoRemetente" :src="notificacao.FotoRemetente" class="avatar-img"/>-->
<!--                  <img v-else-if="getTheme == 'uca'" src="../assets/img/uca/avatar-icon.png" class="avatar-img"/>-->
<!--                  <img v-else-if="getTheme == 'esn'" src="../assets/img/esn/avatar-icon.png" class="avatar-img"/>-->
<!--                </div>-->
<!--                <div class="media-body">-->
<!--                  <h6>{{ notificacao.DisplayNomeRemetente }}</h6>-->
<!--                  <p class="noti-details">{{ notificacao.Assunto }}</p>-->
<!--                  <p class="text-xs text-muted m-0">{{ notificacao.CriadoEm }}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->

<!--          </ul>-->
<!--        </div>-->

      </div>
    </li>

  </ul>
</template>
<script>
import authService from "../Services/Auth.service";
import userService from "../helpers/user.service.js";
import Helper from "../helpers/helper.service";
import mensagemService from '../Services/Mensagem.service'
import eventBus from '../helpers/event.bus';
import MenuLogin from "../mixins/menu.login.mix";
import { useI18n } from 'vue-i18n';
import notificacaoCacheService from '../helpers/notificacao.cache.service'
import modoAlunoService from '../Services/ModoAluno.service'
import ModalConfiguracoesUsuario from './ModalConfiguracoesUsuario.vue'

const { INTERVALO_VERIFICACAO_NOTIFICACAO } = notificacaoCacheService

export default {
  components: { ModalConfiguracoesUsuario },
  mixins: [MenuLogin],
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  data() {
    return {
      usuario: null,
      Mensagens: null,
      Notificacoes: null,
      temNova: false,
      darkModeEnabled: false,
      unsubscribeUserUpdated: null,
      onPageShowNotificacao: null,
      notificacaoIntervalId: null,
      abrirModalConfiguracoes: false,
    }
  },
  async mounted() {

    this.unsubscribeUserUpdated = userService.onUserUpdated(() => {
      this.usuario = userService.getUser();
    });

    this.usuario = userService.getUser()

    if (this.temPermissaoMensagem && this.podeVerificarNotificacao()) {

      this.aplicarNotificacoesCache()

      this.onPageShowNotificacao = (event) => {
        if (event.persisted) {
          this.getNotificacao(true)
        }
      }
      window.addEventListener('pageshow', this.onPageShowNotificacao)

      if (this.foiRefreshPagina()) {
        await this.getNotificacao(true)
      } else {
        await this.getNotificacao()
      }

      this.notificacaoIntervalId = setInterval(async () => {
        if (document.visibilityState === 'visible') {
          await this.getNotificacao()
        }
      }, 60000); // 1 min

    }

  },
  beforeUnmount() {
    if (this.unsubscribeUserUpdated)
      this.unsubscribeUserUpdated();
    if (this.onPageShowNotificacao)
      window.removeEventListener('pageshow', this.onPageShowNotificacao);
    if (this.notificacaoIntervalId) {
      clearInterval(this.notificacaoIntervalId)
      this.notificacaoIntervalId = null
    }
  },
  computed: {
    temPermissaoMensagem() {
      if (!userService.isAuthenticated())
        return false
      return userService.checkPermision('Mensagem')
    },
    usuarioAdministrativo() {
      if (!this.usuario)
        return false
      if (modoAlunoService.checkModoAluno())
        return false
      return !!(this.usuario.Admin || this.usuario.TipoUsuario === 'administrativo')
    },
    getTheme() {
      return Helper.getTheme()
    },
    currentLocale() {
      return Helper.currentLocale();
    },
    currentLanguageLabel() {
      const labels = {
        'pt-BR': 'PT',
        'es': 'ES',
        'en': 'EN'
      };
      return labels[this.locale] || 'PT';
    },
  },
  methods: {
    abrirConfiguracoes() {
      this.fecharDropdownUsuario()
      this.abrirModalConfiguracoes = true
    },
    fecharDropdownUsuario() {
      const toggle = this.$el?.querySelector?.('.user-nav .dropdown-toggle')
      if (toggle && window.bootstrap?.Dropdown) {
        window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide()
      }
    },
    irParaMensagens(tipo) {
      const destino = userService.getRotaMensagens(tipo === 'notificacao' ? 'notificacao' : null)
      this.fecharDropdownNotificacoes()
      this.$router.push(destino)
    },
    fecharDropdownNotificacoes() {
      const toggle = this.$el?.querySelector?.('.noti-nav .dropdown-toggle')
      if (toggle && window.bootstrap?.Dropdown) {
        window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide()
      }
    },
    changeLanguage(lang) {
      this.locale = lang;
      localStorage.setItem('app-locale', lang);
      // Recarrega a página para aplicar as mudanças de idioma em todos os componentes
      window.location.reload();
    },
    foiRefreshPagina() {
      const [navigationEntry] = performance.getEntriesByType('navigation')
      return navigationEntry?.type === 'reload'
    },
    lerNotificacoesCache() {
      return notificacaoCacheService.lerNotificacoesCache()
    },
    salvarNotificacoesCache(mensagens, notificacoes, timestamp = Date.now()) {
      notificacaoCacheService.salvarNotificacoesCache(mensagens, notificacoes, timestamp)
    },
    aplicarNotificacoesCache() {
      const dados = this.lerNotificacoesCache()
      if (!dados) return false

      this.Mensagens = dados.mensagens
      this.Notificacoes = dados.notificacoes
      this.emitirNotificacao(dados.mensagens, dados.notificacoes)
      return true
    },
    emitirNotificacao(mensagens, notificacoes) {

      if (mensagens > 0 || notificacoes > 0) {
        this.temNova = true
      } else {
        this.temNova = false
      }

      const evento = new CustomEvent('MensagensNotificacao', {
        detail: {mensagens, notificacoes}
      });
      eventBus.dispatchEvent(evento); // Emite o evento com o payload

    },
    podeVerificarNotificacao() {
      if (!userService.isAuthenticated())
        return false

      const path = (this.$route?.path || window.location.pathname || '').toLowerCase()
      const primeiraRota = `/${path.split('/').filter(Boolean)[0] || ''}`

      if (window.rotasSemAuth?.includes(primeiraRota) || path === '/login' || path.startsWith('/login/'))
        return false

      return true
    },
    async getNotificacao(forcar = false) {

      if (!this.podeVerificarNotificacao())
        return

      try {

        const agora = Date.now()
        const dadosCache = this.lerNotificacoesCache()

        if (!forcar && dadosCache && agora - dadosCache.timestamp < INTERVALO_VERIFICACAO_NOTIFICACAO) {
          this.aplicarNotificacoesCache()
          return
        }

        const result = await mensagemService.getNotificacaoNaoLidas()

        if (result.Success) {
          const mensagens = parseInt(result.Data.mensagens)
          const notificacoes = parseInt(result.Data.notificacoes)

          this.salvarNotificacoesCache(mensagens, notificacoes, agora)
          this.Mensagens = mensagens
          this.Notificacoes = notificacoes
          this.emitirNotificacao(mensagens, notificacoes)
        }

      } catch (e) {
        console.error('Erro ao buscar novas mensagens do usuário')
      }

    }
  },
}
</Script>

<style scoped>

.header-navbar-rht .dropdown-menu {
  min-width: 220px;
  padding: 0;
}

.topnav-dropdown-header > span {
  cursor: default;
}

.notification-message:hover {
  cursor: default;
  background-color: #f6f6f6;
}

/* Language Selector Styles */
.language-selector .dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #333;
  text-decoration: none;
}

.language-selector .dropdown-toggle:hover {
  color: #258F71;
}

.language-selector .dropdown-menu {
  padding: 8px 0;
}

.language-selector .dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-selector .dropdown-item:hover {
  background-color: #f6f6f6;
}

.language-selector .dropdown-item.active {
  background-color: #258F71;
  color: white;
}

.language-selector .flag-icon {
  font-size: 18px;
}

.notification-toggle {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.notification-label {
  line-height: 1.1;
  text-align: left;
}

.notification-icon--muted {
  filter: grayscale(100%);
}

.notification-icon--pulse {
  animation: notification-grayscale-pulse 1.5s ease-in-out infinite;
}

@keyframes notification-grayscale-pulse {
  0%, 100% {
    filter: grayscale(0%);
  }
  50% {
    filter: grayscale(100%);
  }
}

</style>
